import { BaseModel } from '@core/data-access';
import { Expose } from 'class-transformer';

export class CompanyModel extends BaseModel {
  @Expose() name!: string;
  @Expose() uen!: string;
}
